import { useContext } from 'react'

import { NavigationContainerContext } from '../NavigationContainerProvider/context'

export const useNavigationContainer = () => useContext(NavigationContainerContext)
